var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00024 12.9407C4.00024 17.2901 6.31429 21.0991 9.7784 23.2037L7.94599 23.5071C7.51654 23.5782 7.14151 23.8378 6.92386 24.2148L4.4287 28.5366C4.02703 29.2323 4.2654 30.1219 4.96112 30.5236L6.8764 31.6294C7.57212 32.031 8.46173 31.7927 8.86341 31.0969L12.2669 25.2019C12.4159 24.9439 12.4758 24.672 12.4638 24.411C13.5817 24.7552 14.7693 24.9406 16.0001 24.9406C22.6275 24.9406 28 19.568 28 12.9407C28 6.31332 22.6275 0.940796 16.0001 0.940796C9.37277 0.940797 4.00024 6.31332 4.00024 12.9407ZM16.7127 20.2434C18.1913 19.4642 21.4543 17.2618 21.4543 12.9986C21.4543 9.9543 19.0121 7.48644 15.9996 7.48644C12.987 7.48644 10.5449 9.9543 10.5449 12.9986C10.5449 15.8571 12.6981 18.2074 15.4549 18.4835C15.7546 18.5136 15.9996 18.7549 15.9996 19.0561V19.7877C15.9996 20.1694 16.3751 20.4213 16.7127 20.2434Z",
    fill: "#02C37E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSearchIcon);
export default __webpack_public_path__ + "static/media/greenSearchIcon.81c3a555bd9defd4dca3d3100cfaad2f.svg";
export { ForwardRef as ReactComponent };